import ArrowUp from "@/Icons/ArrowUp";

import { twMerge } from "tailwind-merge";

export const RatingChangeCell: React.FC<{ mv: number }> = ({ mv }) => {
  const up = mv > 0;
  const down = mv < 0;
  const color = up ? "text-carrot-green" : down ? "text-tomato" : "text-grey3";

  return (
    <span
      className={twMerge(
        "flex w-[26px] flex-none items-center justify-center gap-[2px] leading-none",
        color,
      )}
    >
      <span className={twMerge(down && "rotate-180")}>
        {up || down ? <ArrowUp /> : "–"}
      </span>
      {(up || down) && (
        <span className="text-[10px] font-bold">{Math.abs(mv)}</span>
      )}
    </span>
  );
};
